import Vue from 'vue';
import Vuex, {Commit, Dispatch} from 'vuex';
import {initialHub, IHub, IVuexStore, IActionsSignature, IActiveShipment} from "@/models/StoreModels";
import ShipmentModule from "@/store/modules/Shipment";
import ActiveShipmentsModule from "@/store/modules/activeShipments";
import historyModule from "@/store/modules/history";
import HubsModule from "@/store/modules/Hubs";
import SystemModule from "@/store/modules/System";
import UserDataModule from "@/store/modules/UserData";

import {logBus} from "@/services/logBus";
import VuexPersistence from "vuex-persist";
import {IClickAndCollectApi, IUserData} from "@/models/ApiModels";
import * as services from "@/services/services";
import UserData from "@/store/modules/UserData";

Vue.use(Vuex);

const minutesToMilliseconds = (myMinutes: number): number => myMinutes * 60000; // return seconds

let updateInterval: number = 0;




const myGetters = {
  getCCApiBody(state: any, gettersCall: { [key: string]: any}): IClickAndCollectApi {
    return {
      name: gettersCall['shipment/getCCName'],
      comments: gettersCall['shipment/getCCSComments'],
      shop_address: gettersCall['shipment/getCCShopAddress'],
      phone_number: gettersCall['shipment/getCCPhoneNumber'],
      hub: gettersCall['shipment/getCCHub'].address,
      user_id: gettersCall["userData/getId"],
    };
  },

  getDefaultHub(state: any, gettersCall: { [key: string]: any}) {
    const hubId: number|null = gettersCall['userData/getDefaultHubId'] as number|null;
    let currentDefaultHub: IHub = initialHub();
    if (hubId) {
      currentDefaultHub = gettersCall['hubs/getHubById'](hubId);
    }
    return currentDefaultHub;
  },
};

const actions = {
  initStore({ dispatch }: IActionsSignature<IVuexStore> ): Promise<any> {
    return Promise.all([
      dispatch('hubs/init'), // in the future we will init more modules
      dispatch('activeShipments/init'), // in the future we will init more modules
    ])
      .then(() => {
        updateInterval = setInterval(() => {
          return dispatch('activeShipments/init');
        }, minutesToMilliseconds(5));
      }) // on success, we will update active shipments every 3 minutes
      .catch(err => logBus.emit('COMM', 'ERROR:' + ' setServiceProviderId promise', err));
  },

  resetStore({ dispatch }: IActionsSignature<IVuexStore> ): Promise<any> {
    clearInterval(updateInterval);
    updateInterval = 0;

    return Promise.all([
      dispatch('shipment/reset'),
      dispatch('activeShipments/reset'),
      dispatch('hubs/reset'),
      dispatch('userData/reset'),
    ]);
  },

  /**
   * sends the new shipment in the vuex to the api, and after that updates the activeShiptment information
   * @param commit
   * @param dispatch
   */
  createCrosstownShipment({commit, dispatch}: IActionsSignature<IVuexStore> ): Promise<any> {
    return dispatch('shipment/createCrosstownShipment')
            .then((res: IActiveShipment): Promise<IActiveShipment> => {
              return dispatch('activeShipments/init')
                          .then(() => res);
            }); // in the future we will init more modules
  },
  /**
   * sends the new shipment in the vuex to the api, and after that updates the activeShiptment information
   * @param commit
   * @param dispatch
   */
  createAmazonReturnsShipment({commit, dispatch}: IActionsSignature<IVuexStore> ): Promise<any> {
    return dispatch('shipment/createAmazonReturnsShipment')
            .then((res: IActiveShipment): Promise<IActiveShipment> => {
              return dispatch('activeShipments/init')
                          .then(() => res);
            }); // in the future we will init more modules
  },

  sendCCToApi({ getters }: IActionsSignature<IVuexStore> ) {
    return services.apiCaller.POST("/shipments/clickAndCollect", getters.getCCApiBody);
  },

  sendCCCorteInglesToApi({ getters }: IActionsSignature<IVuexStore> ) {
    return services.apiCaller.POST("/shipments/corteIngles");
  },

  /**
   * updates the default hub in the backend and then updates the user in the store
   * @param dispatch
   * @param hubId
   */
  setDefaultHubId({dispatch}: IActionsSignature<IVuexStore>, hubId: number) {
    return services.apiCaller.PATCH("/user/defaultHub", { default_hub_id: hubId })
      .then((user: IUserData) => dispatch('userData/setUserData', user));
  },
};


const vuexLocal = new VuexPersistence<IVuexStore>({
  storage: window.localStorage,
});

export default new Vuex.Store<IVuexStore>({
  mutations: {},
  getters: myGetters,
  actions,
  plugins: [vuexLocal.plugin],
  modules: {
    shipment: ShipmentModule,
    activeShipments: ActiveShipmentsModule,
    hubs: HubsModule,
    userData: UserDataModule,
    history: historyModule,
    system: SystemModule,
  },
});

